import React from 'react';
import { compose, withHandlers, withState } from 'recompose';
import { connect } from 'react-redux';
import { ObjectShim } from '@packages/helpers/core/shims/object-shim';
import { sendStatus } from '../../../store/reducers/status-data';
import { setUserMarketingPreferences } from '../../../store/reducers/account/actions';
import { AccountPage } from '../../../templates/account';
import { withBarrier } from '../../barrier';
import { MarketingLists, withoutMarketingLists } from '../components';
import { withMarketingListData } from '../hocs/with-marketing-data';

const Component = React.memo(({ values, handleChange, loading }) => {
  const {
    ACCOUNT: {
      MAIN: {
        pages: {
          marketing: { title, identifier, subheading, inPageMessage, message, heading, body, pageHeader }
        }
      }
    }
  } = window.CONFIG;

  return (
    <AccountPage
      title={title}
      subheading={subheading}
      category={identifier}
      inPageMessage={inPageMessage}
      message={message}
      heading={heading}
      body={body}
      pageHeader={pageHeader}
    >
      <MarketingLists values={values} onChange={handleChange} disabled={loading} />
    </AccountPage>
  );
});

export const AccountMarketing = compose(
  withBarrier,
  connect(null, { sendStatus, setUserMarketingPreferences }),
  withMarketingListData,
  withoutMarketingLists('/account'),
  withState('values', 'setValue', ({ lists, subscribtions }) => {
    return lists.reduce(
      (values, { id }) => ({
        ...values,
        [id]: subscribtions.includes(id)
      }),
      {}
    );
  }),
  withHandlers({
    handleChange:
      ({ values, setValue, setUserMarketingPreferences }) =>
      (id, checked) => {
        const nextValues = { ...values, [id]: checked };

        setUserMarketingPreferences(ObjectShim.truthyKeys(nextValues), () => {
          setValue(nextValues);
        });
      }
  })
)(Component);
